import React from 'react';
import PropTypes from 'prop-types';
import IconProtected from 'assets/icons/protected.svg';
import { formatText } from 'core/i18n';
import { ItemList } from '../itemList/itemList';
import './MoreInformationModal.scss';
import { ModalComponent } from '../modal/modalComponent';

const TRANSLATION_CONTEXT = 'signaturekeyModal';
export const MoreInformationModal = ({ isOpen, closeAction }) => (
    <ModalComponent
        isOpen={isOpen}
        onConfirm={closeAction}
        onCancel={closeAction}
        title={formatText(`${TRANSLATION_CONTEXT}-title`)}
        confirmText={formatText('button-understood')}
        className="more-information-modal"
    >
        <div className="more-information-modal-body-container">
            <img src={IconProtected} alt="protected-icon" className="protected-icon" />

            <div>
                <h4 className={'subtitle'}>{formatText(`${TRANSLATION_CONTEXT}-subtitle1`)}</h4>
                <p>{formatText(`${TRANSLATION_CONTEXT}-text1`)}</p>
            </div>

            <div>
                <h4 className={'subtitle'}>{formatText(`${TRANSLATION_CONTEXT}-subtitle2`)}</h4>
                <ItemList
                    className="more-information-modal-list"
                    items={[
                        formatText(`${TRANSLATION_CONTEXT}-text2`),
                        formatText(`${TRANSLATION_CONTEXT}-text3`),
                        formatText(`${TRANSLATION_CONTEXT}-text4`),
                    ]}
                />
                <p>{formatText(`${TRANSLATION_CONTEXT}-text5`)}</p>
            </div>
        </div>
    </ModalComponent>
);

MoreInformationModal.propTypes = {
    isOpen: PropTypes.bool,
    closeAction: PropTypes.func,
};
